import { proxy } from 'valtio';

/**
 * Lets applet UI (e.g. submit handlers) ask {@link AppletGuard} to show the sign-in modal again
 * after the user dismissed it.
 */
export const appletSignInModalStore = proxy({
  openRequestVersion: 0,
});

export function requestAppletSignInModal() {
  appletSignInModalStore.openRequestVersion += 1;
}
